import { Prisma } from "@prisma/client";

export const notificationValues = Prisma.validator<Prisma.NotificationDefaultArgs>()({
    include: {
        picture: true,
    }
});


export type Notification = Prisma.NotificationGetPayload<typeof notificationValues>;